import type { SwiperOptions } from 'swiper/types';
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules';

const SWIPER_OPTIONS: Record<string, SwiperOptions> = {
  default: {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      clickable: true,
    },
    breakpoints: {
      400: {
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
    },
  },
  mainCarousel: {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoHeight: true,
    pagination: {
      el: '',
      clickable: true,
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
  },
  smallCarousel: {
    modules: [Navigation],
    loop: true,
    slidesPerView: 2,
    spaceBetween: 30,
    breakpoints: {
      400: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 6,
      },
    },
  },
  shortsCarousel: {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 16,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  },
  bannersCarousel: {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 20,
    loop: true,
    pagination: {
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      1000: {
        slidesPerView: 4,
      },
    },
  },
  articlesCarousel: {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    pagination: {
      clickable: true,
      dynamicBullets: true,
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  },
  productsCarousel: {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: '',
      clickable: true,
    },
    breakpoints: {
      560: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  },
  productsCarouselCompare: {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 8,
    pagination: {
      el: '',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  },
  productsAttributesCarouselCompare: {
    slidesPerView: 2,
    spaceBetween: 8,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
    allowTouchMove: false,
  },
  productGallery: {
    slidesPerView: 5,
    spaceBetween: 20,
  },
  productMain: {
    modules: [Navigation, Thumbs, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
  },
  categories: {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
      1400: {
        slidesPerView: 6,
      },
    },
  },
  articleProducts: {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  },
};

export function getSwiperOptions(name: string) {
  return {
    ...SWIPER_OPTIONS[name],
  };
}
